import { defineMessages } from "react-intl";

export default defineMessages({
  pricesWarning: {
    id: "prices.warning",
    defaultMessage: "The price is only an estimate and may differ from the retailer price offered by distributors. The price is including VAT."
  }
});